import api from '@/services/api'

export const deleteKeyResultFromAPI = (objectiveId, keyResultId) => {
    return api.delete(`objectives/${objectiveId}/keyresults/${keyResultId}`)
}
